module.exports = __webpack_public_path__ + "static/media/getting-started-icon.24d7beb3.png";